import { render, staticRenderFns } from "./LayoutAccountNav.vue?vue&type=template&id=2d36ac8d&scoped=true"
import script from "./LayoutAccountNav.vue?vue&type=script&lang=js"
export * from "./LayoutAccountNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutAccountNav.vue?vue&type=style&index=0&id=2d36ac8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36ac8d",
  null
  
)

export default component.exports